import moment from "moment";
import "moment/locale/id";

export default {
  data() {
    return {
      timeoutSearch: null,
      serverParams: {},
    };
  },
  created() {
    moment.updateLocale("en", {
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ],
    });
  },
  methods: {
    currencyFormat(value) {
      if (!value) return "";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    currencyexcelFormat(value) {
      if (!value) return "";
      return "Rp. " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    indonesianFormat(dateTime) {
      return moment.unix(dateTime).format("D MMMM YYYY");
    },
    dateFormat(dateTime) {
      if (dateTime) {
        return moment(dateTime).format("DD-MM-YYYY H:m:s");
      } else {
        return "-";
      }
    },
    datetimeFormat(dateTime) {
      if (dateTime) {
        return moment(dateTime).format("DD-MM-YYYY H:m:s");
      } else {
        return "-";
      }
    },
    dateclockFormat(dateTime) {
      if (dateTime) {
        return moment(dateTime).format("DD-MM-YYYY HH:mm");
      } else {
        return "-";
      }
    },
    datefromNow(dateTime) {
      moment.locale("id");
      if (dateTime) {
        return moment(dateTime).fromNow();
      } else {
        return "-";
      }
    },
    datefromNowComplete(dateTime) {
      moment.locale("id");
      if (!dateTime) return "-";

      const mDate = moment(dateTime);
      const now = moment();

      const diffDays = now.diff(mDate, "days");

      if (diffDays > 30) {
        // return mDate.format("DD-MM-YYYY HH:mm");
        return `${mDate.fromNow()} Tanggal ${mDate.format("DD-MM-YYYY HH:mm")}`;
      } else {
        return `${mDate.fromNow()} ${mDate.format("HH:mm")}`;
      }
    },
    dateinputFormat(dateTime) {
      if (dateTime) {
        return moment(dateTime).format("YYYY-MM-DD");
      } else {
        return "-";
      }
    },
    truncateText(value) {
      if (value) {
        const words = value.split(" ");
        const wordLimit = 10;

        if (words.length <= wordLimit) {
          return value;
        } else {
          return words.slice(0, wordLimit).join(" ") + " [...]";
        }
      } else {
        return "";
      }
    },
    fulldatetimeFormat(dateTime) {
      moment.locale("id");
      if (dateTime) {
        return moment(dateTime).format("dddd, DD MMMM YYYY, hh:mm:ss a");
      } else {
        return "-";
      }
    },
  },
};
